import { render, staticRenderFns } from "./index.vue?vue&type=template&id=efc02e02&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc02e02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efc02e02')) {
      api.createRecord('efc02e02', component.options)
    } else {
      api.reload('efc02e02', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=efc02e02&scoped=true", function () {
      api.rerender('efc02e02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/setting-phone/index.vue"
export default component.exports